module.exports = __webpack_public_path__ + "img/markerOne.b8394aca.png";